export default __webpack_public_path__ + "static/media/image9.531848ba.png";